import { render, staticRenderFns } from "./formMarker.vue?vue&type=template&id=59940f38&"
import script from "./formMarker.vue?vue&type=script&lang=js&"
export * from "./formMarker.vue?vue&type=script&lang=js&"
import style0 from "./formMarker.vue?vue&type=style&index=0&id=59940f38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports